"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _addAnalyticsAndCommerceScripts = _interopRequireDefault(require("../addAnalyticsAndCommerceScripts"));
var allAgreements = {
  gtm: true,
  analytics: true,
  pixelFb: true,
  salesmanago: true
};
var setAgreements = function setAgreements(_ref) {
  var _ref$agreements = _ref.agreements,
    agreements = _ref$agreements === void 0 ? true : _ref$agreements,
    cookieAgreements = _ref.cookieAgreements,
    language = _ref.language;
  var setCookieAgreements = cookieAgreements.setCookieAgreements,
    analyticsID = cookieAgreements.analyticsID,
    gtmID = cookieAgreements.gtmID,
    fbID = cookieAgreements.fbID;
  var currentAgreements = agreements === true ? allAgreements : {
    gtm: agreements.analytic,
    analytics: agreements.analytic,
    pixelFb: agreements.tracking,
    salesmanago: agreements.tracking
  };
  setCookieAgreements(currentAgreements);
  var currentLanguage = language === null || language === void 0 ? void 0 : language.language;
  (0, _addAnalyticsAndCommerceScripts["default"])(currentLanguage, currentAgreements, {
    analyticsID: analyticsID,
    gtmID: gtmID,
    fbID: fbID
  });
};
var _default = setAgreements;
exports["default"] = _default;